import {ApiEventTemplatesPermissions} from "../constants/ApiPermissions";
import RulesetBase from "./rulesetBase";

/**
 * Ruleset for event catalogue.
 *
 * @class
 * @extends {RulesetBase}
 */
class EventCatalogueRuleset extends RulesetBase {
  defineRules = (userPermissions: string[]): void => {
    const {can} = this.abilityBuilder;
    let onlyRead = false;

    for (let permission of userPermissions) {
      if (
        permission.toUpperCase() ===
        ApiEventTemplatesPermissions.readWrite.toUpperCase()
      ) {
        can("Create", "EventCatalogue");
        can("Delete", "EventCatalogue");
        can("Update", "EventCatalogue");
        can("Read", "EventCatalogue");
        onlyRead = false;
        break;
      } else if (
        permission.toUpperCase() ===
        ApiEventTemplatesPermissions.read.toUpperCase()
      ) {
        onlyRead = true;
      }
    }
    if (onlyRead) {
      can("Read", "EventCatalogue");
    }
  };
}

export default EventCatalogueRuleset;
